import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { useState } from 'react';
import VerifyDomain from 'components/onboarding/verifyDomain';
import styles from 'styles/components/verifyDomainBanner.module.scss';
import { LOCAL_STORAGE } from 'utils/constants';

/**
 * Upgrade flow: verification is optional, except when someone else already
 * has this domain name (`claimed`); then requests fail until it's verified.
 */
const VerifyDomainBanner = ({ domain }) => {
  const [open, setOpen] = useState(false);

  if (!domain || domain.verified) {
    return null;
  }

  const openVerify = () => {
    // VerifyDomain reads the domain to verify from localStorage.
    localStorage.setItem(LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION, domain.name);
    setOpen(true);
  };

  const close = () => {
    localStorage.removeItem(LOCAL_STORAGE.CURRENT_DOMAIN_VALIDATION);
    setOpen(false);
  };

  return (
    <>
      <div
        className={`${styles.banner}${domain.claimed ? ` ${styles.claimed}` : ''}`}
      >
        <SafetyCertificateOutlined className={styles.icon} />
        <div className={styles.text}>
          {domain.claimed ? (
            <>
              <strong>This domain is already listed</strong>
              <p>
                Verify that you own <b>{domain.name}</b> before you can request
                backlinks.
              </p>
            </>
          ) : (
            <>
              <strong>Verify your domain</strong>
              <p>
                Verify <b>{domain.name}</b> to show members it's really yours.
              </p>
            </>
          )}
        </div>
        <Button className={styles.button} onClick={openVerify}>
          Start verification
        </Button>
      </div>
      <Modal open={open} onCancel={close} footer={null} width={720} destroyOnClose>
        <VerifyDomain
          nextStep={close}
          previousStep={close}
          nextLabel="Back to opportunities"
          allowUseAnother={false}
        />
      </Modal>
    </>
  );
};

export default VerifyDomainBanner;
